// Browser-only persistence for the Rights Dashboard. v1 keeps the whole Live
// Calculation State in localStorage so the data model can keep moving without DB
// migrations. (Single-device; we migrate durable entities to Postgres later.)
import { blankProject, SCHEMA_VERSION } from './model';

const KEY = 'rights-dashboard-project';

export function loadProject() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Drop state from an older shape rather than rendering it half-migrated.
    if (!parsed || parsed.schemaVersion !== SCHEMA_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveProject(project) {
  try {
    localStorage.setItem(KEY, JSON.stringify(project));
  } catch {
    /* quota / private mode — ignore, state stays in memory */
  }
}

export function clearProject() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

export function initialProject() {
  return loadProject() || blankProject();
}
